import cn from "@/v1-ui/utils/utils.cn"
import Frame, { type FrameHeaderProps } from "@/v1-ui/Frame"

export type Dialog2HeaderProps = FrameHeaderProps

function Dialog2Header(props: Dialog2HeaderProps) {
  const { className, ...frameHeaderProps } = props
  return (
    <Frame.Header
      className={cn("dialog2-header", className)}
      {...frameHeaderProps}
    />
  )
}

export default Dialog2Header
